import { useAsyncFn } from 'react-use';

import { verifyEmail } from 'supertokens-auth-react/recipe/emailverification';

export const useVerifyEmail = () => {
  return useAsyncFn(async () => {
    const { status } = await verifyEmail();
    if (status === 'OK') {
      return true;
    } else if (status === 'EMAIL_VERIFICATION_INVALID_TOKEN_ERROR') {
      throw new Error('Email verification invalid token');
    } else {
      throw new Error('Unknown error');
    }
  });
};
